import * as React from 'react';
import {signal} from '@preact/signals-react';

import {CompareItem} from '../item.class';
import {InfoModal} from '../../ui/modals/InfoModal/InfoModal';
import {LocalStorageService} from '../../../client/local-storage/local-storage.service';

const localStorageService = new LocalStorageService();
const compareItemsString = localStorageService.getItem(`compareItems`);

export const compareItems = signal<CompareItem[]>(compareItemsString ? JSON.parse(compareItemsString) : []);
const showAlreadyCompared = signal(false);
const showThreeMessage = signal(false);

/**
 * Compare modals should be included on any page that intends to use addItem(). To inform the user of conflicts.
 * @constructor
 */
export const CompareModals = () => {
    return (
        <>
            <InfoModal
                message="You can compare up to three items at a time"
                modalTitle="Compare"
                onClose={() => {
                    showThreeMessage.value = false;
                }}
                show={showThreeMessage.value}
                showOkButton={true}
            />
            <InfoModal
                message="You are already comparing this item."
                modalTitle="Compare"
                onClose={() => {
                    showAlreadyCompared.value = false;
                }}
                show={showAlreadyCompared.value}
                showOkButton={true}
            />
        </>
    );
};

/**
 * Add a new compareItems, and persist to local storage
 * @param itemNum
 * @param imagePath
 */
export const addItem = (itemNum: string, imagePath: string) => {
    let alreadyHasItem = false;

    // Determine if itemNum has already been added
    if (compareItems.value.length) {
        for (const compareItem of compareItems.value) {
            if (compareItem.itemNum === itemNum) {
                alreadyHasItem = true;
            }
        }
    }

    // Add itemNum to compareItems
    if (alreadyHasItem) {
        showAlreadyCompared.value = true;
        return;
    }

    // Check if max comparison has been reached
    if (compareItems.value.length > 2) {
        showThreeMessage.value = true;
        return;
    }

    // Render compareItems
    compareItems.value = [...compareItems.value, {itemNum, imagePath}];
    localStorageService.setItem(`compareItems`, JSON.stringify(compareItems.value));
};

/**
 * Remove given compareItems, and persist to local storage
 * @param itemNum
 */
export const removeItem = (itemNum: string) => {
    compareItems.value = compareItems.value.filter((compareItem) => {
        return compareItem.itemNum !== itemNum;
    });
    localStorageService.setItem(`compareItems`, JSON.stringify(compareItems.value));
};

/**
 * Remove all compareItems, and persist to local storage
 */
export const removeAllItems = () => {
    compareItems.value = [];
    localStorageService.removeItem(`compareItems`);
};
